<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GZZW8p/tc-custom/9781439663981.jpg?1702529291348" alt="This image is the cover for the book Historic Restaurants of Tucson, American Palate"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Historic Restaurants of Tucson, American Palate
      </h1>
      <p class="bookDescription body article font2">
        <p>Tucson's culinary journey began thousands of years ago, when Native American tribes developed an agricultural base along the Santa Cruz River. In modern times, restaurants ranging from tiny taquerias to fine dining spaces all contributed to the local food culture. El Charro, serving Mexican cuisine since 1922, still attracts crowds from all over. Folks head straight to Pat's for a hot dog, Lucky Wishbone for some fried chicken or eegee's for a grinder and a cold, frosty drink. On any given night, the patio at El Corral is filled with diners anticipating their famous prime rib and tamale pie. Local food writer Rita Connelly brings to life the stories of beloved eateries that have endured for decades and continue to delight with incredible flavors.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rita Connelly
      </h2>
      
      <p class="authorDescription body article">Rita Connelly has lived in Tucson since 1979 with her husband, John, and daughter, Riene. Somewhere in her travels, she earned a BA in education from the University of Arizona. She worked as a restaurant reviewer for the Tucson Weekly for ten years. During that time, she acted as a judge for hot dog, wine, tequila, salsa, chocolate and pie competitions. Her book, Lost Restaurants of Tucson, was published in 2015. She chronicles her food adventures in her blog, thewellfedfoodieblog@wordpress.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7949834c